import '../../style/Authflow.css';

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FORM_ERROR } from 'final-form';
import { sendPasswordResetEmail } from 'firebase/auth';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import { connect } from 'react-redux';

import { actions } from 'coupon-common/src/modules/passwords/duck';
import { dispatchAsAsync } from 'coupon-common/src/utils';
import {
  composeSyncValidators,
  required,
  validEmail,
} from 'coupon-common/src/utils/validation';

import Logo from '../../Logo/Logo';
import { firebaseAuth } from '../../firebase';

// Maps Firebase auth error codes to a single user-facing message,
// mirroring the generic-on-purpose approach used in CustomerLogin.
const getFirebaseErrorMessage = errorCode => {
  switch (errorCode) {
    case 'auth/network-request-failed':
      return 'Network error. Please try again.';
    default:
      return 'An unexpected error occurred. Please try again.';
  }
};

export const ForgotPassword = ({ dispatch }) => {
  const navigate = useNavigate();
  const [successed, setSuccessed] = useState(false);

  const onSubmit = async values => {
    const { email } = values;

    try {
      await sendPasswordResetEmail(firebaseAuth, email);
      setSuccessed(true);
      return undefined;
    } catch (error) {
      if (error.code === 'auth/user-not-found') {
        const fallbackErrors = await dispatchAsAsync(
          actions.recoverPassword(email),
          dispatch,
        );
        if (!fallbackErrors) {
          setSuccessed(true);
        }
        return fallbackErrors;
      }
      console.error('Firebase password reset error:', error);
      return { [FORM_ERROR]: getFirebaseErrorMessage(error.code) };
    }
  };

  const renderForm = ({ handleSubmit, submitting, submitError }) => (
    <form className="auth-form" onSubmit={handleSubmit}>
      <Field
        name="email"
        validate={composeSyncValidators(required, validEmail())}
      >
        {({ input, meta }) => (
          <div className="auth-field">
            <label className="auth-field-label" htmlFor="email">
              Email
            </label>
            <input
              {...input}
              id="email"
              type="email"
              autoComplete="email"
              className="auth-field-input"
            />
            {meta.touched && meta.error && (
              <div className="auth-field-error">{meta.error}</div>
            )}
          </div>
        )}
      </Field>

      {submitError && <div className="auth-form-error">{submitError}</div>}

      <button
        type="submit"
        disabled={submitting}
        className="auth-btn auth-btn-solid auth-btn-block"
      >
        Send Recovery Email
      </button>

      <button
        type="button"
        onClick={() => navigate(-1)}
        className="auth-btn auth-btn-outline auth-btn-block"
      >
        Back
      </button>
    </form>
  );

  return (
    <div className="auth-page auth-forgot-password-page">
      <header className="auth-navbar">
        <button
          type="button"
          className="auth-logo-btn"
          onClick={() => navigate('/')}
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          <Logo light />
        </button>
      </header>

      <div className="auth-card-wrap">
        <div className="auth-card">
          <h2 className="auth-card-title">Password Recovery</h2>

          {successed ? (
            <p className="auth-card-text">
              A link to reset your password has been sent to your e-mail
              address.
            </p>
          ) : (
            <Form onSubmit={onSubmit} render={renderForm} />
          )}
        </div>
      </div>
    </div>
  );
};

ForgotPassword.propTypes = {
  dispatch: PropTypes.func,
};

export default connect()(ForgotPassword);